import React from 'react';
import Header from '../components/Header';
import ContactSection from '../components/ContactSection';
import Chatbot from '../components/Chatbot';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-[#020617] text-slate-100 noise-bg">
      <Header />
      <div className="pt-24">
        <ContactSection />
      </div>
      <Chatbot />
    </div>
  );
};

export default ContactPage;
